import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { ArrangementGroupsOverviewRoute } from './OverviewRoute';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const ArrangmentGroupsRoutes = withLDConsumer()(() => {
  return (
    <ValleyBankTemplate canToggleDataSource>
      <Switch>
        <Route
          exact
          path="/arrangement-groups"
          component={ArrangementGroupsOverviewRoute}
        />
      </Switch>
    </ValleyBankTemplate>
  );
});
